import { render, staticRenderFns } from "./HomePageFooter.vue?vue&type=template&id=1c3fd194&scoped=true&lang=pug&"
import script from "./HomePageFooter.vue?vue&type=script&lang=js&"
export * from "./HomePageFooter.vue?vue&type=script&lang=js&"
import style0 from "./HomePageFooter.vue?vue&type=style&index=0&id=1c3fd194&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c3fd194",
  null
  
)

export default component.exports